// extracted by mini-css-extract-plugin
module.exports = {"container":"Radio_container__3GENA","radio":"Radio_radio__3xB0M","label":"Radio_label__31E0O"};